import { useCallback, useEffect, useState } from "react";

import { apiClient } from "utils/apiClient";

import { getToken } from "auth/helpers/authApi";

import { UserLevel, UserLevelContext } from "../user-level";

export const UserLevelProvider = ({ children }) => {
	const [openLevel, setOpenLevel] = useState(false);
	const [userLevel, setUserLevel] = useState<UserLevel | null>(null);

	const triggerHideLevel = useCallback(async () => {
		setOpenLevel(false);
		try {
			await apiClient("users/user-levels/gained/reset", {
				token: getToken(),
				method: "POST",
			});
		} catch (error) {}
	}, []);

	const fetchUserLevel = useCallback(async () => {
		try {
			const userLevel = await apiClient("users/user-levels/gained", {
				token: getToken(),
			});
			setUserLevel(userLevel.data);
			if (userLevel.data.expGained > 0) {
				setOpenLevel(true);
			}
		} catch (error) {}
	}, []);

	useEffect(() => {
		fetchUserLevel();
	}, [fetchUserLevel]);

	const value = {
		openLevel,
		triggerHideLevel,
		userLevel,
		fetchUserLevel,
	};

	return <UserLevelContext.Provider value={value}>{children}</UserLevelContext.Provider>;
};
